import { Body } from './Body';

export default function Inactive() {
  return <Body title={`Hmm, looks like this survey is no longer active, but we will keep you posted on future opportunities.`} />;
}

export { Inactive };